// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".24cf4b9ffc30ac6f1db9fe589c1f1377bdae4923.chunk.bundle.js";
};